export default [
    {
        name:"Line",
        icon:"fa-chart-line",
        config: {
            seriesOverrides: {
                "type": "scatter",
                "opacity": 1,
                "xbins": {"size": 1},
                "ybins": {"size": 1},
            }
        }
    },
    {
        name:"Scatter",
        icon:"fa-circle",
        config: {
            seriesOverrides: {
                "type": "scatter",
                "opacity": 1,
                "xbins": {"size": 1},
                "ybins": {"size": 1},
                "mode": "markers"
            },
            'layout-overrides':{
                "hovermode":"closest"
            }
        }
    },{
        name:"Summary",
        icon:"fa-circle",
        config: {
            seriesOverrides: {
                "type": "scatter summary",
                "opacity": 1,
                "xbins": {"size": 1},
                "ybins": {"size": 1},
                "mode": "markers",
            },
            'layout-overrides':{
                "hovermode":"closest"
            }
        }
    },
    {
        name:"Stacked Area",
        icon:"fa-chart-area",
        config: {
            seriesOverrides: {
                "type": "scatter",
                "opacity": 1,
                "xbins": {"size": 1},
                "ybins": {"size": 1},
                "fill": "tonexty",
                "mode": "none",
                "stackgroup": "One"
            }
        }
    },
    {
        name:"Bar - group",
        icon:"fa-chart-bar",
        config: {
            seriesOverrides: {
                "type": "bar",
                "opacity": 1,
                "xbins": {"size": 1},
                "ybins": {"size": 1},
                "horizontalBarMode": false,
                "horizontalSummaryMode": false,
                "customUnit": null,
            },
            'layout-overrides':{
                "barmode":"group"
            }
        }
    },
    {
        name:"Bar - stack",
        icon:"fa-chart-bar",
        config: {
            seriesOverrides: {
                "type": "bar",
                "opacity": 1,
                "xbins": {"size": 1},
                "ybins": {"size": 1},
                "horizontalBarMode": false,
                "horizontalSummaryMode": false,
                "customUnit": null,
            },
            'layout-overrides':{
                "barmode":"stack"
            }
        }
    },
    {
        name:"Bar summary",
        icon:"fa-chart-bar",
        config: {
            seriesOverrides: {
                "type": "bar summary",
                "opacity": 1,
                "xbins": {"size": 1},
                "ybins": {"size": 1},
                "horizontalBarMode": false,
                "horizontalSummaryMode": false,
                "customUnit": null
            },
            'layout-overrides':{
                "hovermode":"closest"
            }
        }
    },
    {
        name:"Pie",
        icon:"fa-chart-pie",
        config: {
            seriesOverrides: {"type": "pie", "opacity": 1, "xbins": {"size": 1},"ybins": {"size": 1}},
            'layout-overrides':{
                "hovermode":"closest"
            }
        }
    },
    {
        name:"Heatmap",
        icon:"fa-th",
        config: {
            seriesOverrides: {
                "type": "heatmap",
                "opacity": 1,
                "xbins": {"size": 1},
                "ybins": {"size": 1},
                "showscale":true,
                "colorscale":null
            },
            'layout-overrides':{
                "margin": {"l": 300, "r": 50, "t": 50, "pad": 1},
                "hovermode":"closest"
            }
        }
    },
    {
        name:"Histogram",
        icon:"fa-chart-bar",
        config: {
            seriesOverrides: {
                "type": "histogram",
                "opacity": 0.5,
                "xbins": {"size": 50},
                "ybins": {"size": 50},
            },
            'layout-overrides':{
                "barmode":"overlay"
            }
        }
    },
    {
        name:"Gauge",
        icon:"fa-tachometer-alt",
        config: {
            seriesOverrides: {
                "type": "indicator",
                "mode":"gauge+number",
                "opacity": 1,
                "xbins": {"size": 1},
                "ybins": {"size": 1},
            },
        }
    },
    {
        name:"Number",
        icon:"fa-stopwatch-20",
        config: {
            seriesOverrides: {
                "type": "indicator",
                "mode":"number",
                "opacity": 1,
                "xbins": {"size": 1},
                "ybins": {"size": 1},
            },
        }
    },
]